/**
 * Feature Accordion — template-driven accordion/image gallery sync.
 *
 * The shared accordion-gallery controller owns row-state discovery,
 * editor block selection, and rebuild triggers. This file only owns
 * feature-accordion-specific slide creation from block templates.
 */
(function () {
  'use strict';

  if (!window.FitAccordionGallery || customElements.get('feature-accordion')) return;

  var SLIDE_CLASS = 'fit-fa__slide';
  var ACTIVE_CLASS = 'fit-fa__slide--active';
  var ROW_SELECTOR = '[data-fit-fa-row]';
  var ROW_ATTRIBUTE = 'data-fit-fa-row';
  var SLIDE_ATTRIBUTE = 'data-fit-fa-slide';

  function buildGallery(root, gallery) {
    var templates = root.querySelectorAll('template[data-fit-fa-slide-tpl]');
    if (!(gallery instanceof Element)) return;

    gallery.innerHTML = '';

    templates.forEach(function (template) {
      var blockId = template.getAttribute('data-fit-fa-slide-tpl');
      if (!blockId) return;

      var slide = document.createElement('div');
      slide.className = SLIDE_CLASS;
      slide.setAttribute(SLIDE_ATTRIBUTE, blockId);
      slide.appendChild(template.content.cloneNode(true));
      gallery.appendChild(slide);
    });
  }

  customElements.define(
    'feature-accordion',
    class extends HTMLElement {
      connectedCallback() {
        this._frame = requestAnimationFrame(this._init.bind(this));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._frame);
        this._controller && this._controller.destroy();
        this._controller = null;
        this._gallery = null;
      }

      _init() {
        this._controller && this._controller.destroy();

        this._gallery = this.querySelector('[data-fit-fa-gallery]');
        if (!(this._gallery instanceof Element)) return;

        this._controller = window.FitAccordionGallery.createController(this, {
          rowSelector: ROW_SELECTOR,
          rowAttribute: ROW_ATTRIBUTE,
          getObserveTarget: function (root) {
            return root.querySelector('[data-fit-fa-accordion]');
          },
          onActiveRowChange: this._handleActiveRowChange.bind(this),
          onStructureChange: this._rebuild.bind(this, 'mutation'),
        });

        this._rebuild('init');
      }

      _rebuild(reason) {
        if (!this._controller || !(this._gallery instanceof Element)) return;

        buildGallery(this, this._gallery);
        this._controller.sync(reason || 'rebuild');
      }

      _handleActiveRowChange(info) {
        if (!this._controller || !(this._gallery instanceof Element) || !info || !info.rowId) return;

        this._controller.activateByData(
          this._gallery,
          '[' + SLIDE_ATTRIBUTE + ']',
          ACTIVE_CLASS,
          SLIDE_ATTRIBUTE,
          info.rowId,
        );
      }
    },
  );
})();
